// Matches the legacy `Ld` atom. Spinner + label.

export function Loading({ text = "Loading..." }: { text?: string }) {
  return (
    <div className="flex items-center gap-3 p-10 justify-center">
      <div
        className="w-4 h-4 rounded-full border-2 border-stroke"
        style={{
          borderTopColor: "rgb(var(--color-accent))",
          animation: "spin .8s linear infinite",
        }}
      />
      <span className="font-mono text-[13px] text-muted">{text}</span>
    </div>
  );
}
